module.exports = __webpack_public_path__ + "img/070.e156a675.jpg";